import React from "react";
import Svg, { Path, Defs, G, SvgProps, Rect } from "react-native-svg";

const PlusIcon = (props: SvgProps) => {
  return (
    <Svg fill="none" stroke="#101010" viewBox="0 0 20 20" {...props}>
      <G clipPath="url(#clip0_1184_112)">
        <Path
          d="M3.125 10H16.875"
          stroke="#0E7A41"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M9.99976 3.12476V16.8748"
          stroke="#0E7A41"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <clipPath id="clip0_1184_112">
          <Rect width="20" height="20" fill="white" />
        </clipPath>
      </Defs>
    </Svg>
  );
};

export default PlusIcon;
